import type { AccessTokenProvider, AllowedHostsValidator } from '@microsoft/kiota-abstractions';
import { AllowedHostsValidator as DefaultAllowedHostsValidator } from '@microsoft/kiota-abstractions';
import {msalInstance, tokenRequest} from "@/app/auth/msal-config.ts";

export class MsalAccessTokenProvider implements AccessTokenProvider {
  private readonly allowedHostsValidator: AllowedHostsValidator;

  constructor(allowedHosts?: Set<string>) {
    this.allowedHostsValidator = new DefaultAllowedHostsValidator(allowedHosts || new Set(['localhost', 'your-api-domain.com']));
  }

  public async getAuthorizationToken(): Promise<string> {
    try {
      const activeAccount = msalInstance.getActiveAccount();
      if (!activeAccount) {
        console.error('No active account! Please verify that a user is signed in.');
        return '';
      }

      const response = await msalInstance.acquireTokenSilent({
        ...tokenRequest,
        account: activeAccount,
      });

      return response.accessToken;
    } catch {
      // Attempt to acquire token interactively if silent fails
      try {
        const response = await msalInstance.acquireTokenPopup(tokenRequest);
        return response.accessToken;
      } catch (popupError) {
        console.error('Failed to acquire token interactively', popupError);
        return '';
      }
    }
  }

  public getAllowedHostsValidator(): AllowedHostsValidator {
    return this.allowedHostsValidator;
  }
}
